import { AbstractTransport } from './abstract-transport';

export class DetectSensitiveData extends AbstractTransport {
    constructor(detectSensitiveData) {
        super();
        this.detectSensitiveData = detectSensitiveData;
    }

    log(message) {
        const hasSensitiveData = this.detectSensitiveData(message.parts, 'parts');

        if (hasSensitiveData) {
            console.error('Sensitive data detected', message); // eslint-disable-line no-console
        }
    }
}
